import { ajax } from 'jquery'
import { getIp } from '@/pdaView/utils'

const DeviceConnection = {

  localStorageKey: 'DeviceConnectionConfig',

  // websocke 状态变化时发送消息的 type
  messageType: 'websocketChange',

  lockReconnect: false, //避免重复连接

  socket: null,

  statusChangeCallBackArr: null,

  //wsUrl: 'ws://127.0.0.1:30001', //默认连接本地deviceServer

  //httpUrl: 'http://127.0.0.1:30000', //默认连接本地deviceServer

  testConnectDeviceServer: function(wsUrl, callback) {
    const socket = new WebSocket(wsUrl)
    socket.onopen = function(event) {
      if (typeof callback === 'function') {
        callback(true, event)
      }
      console.log('WebSocket opened!')
    }
    socket.onerror = function(error) {
      if (typeof callback === 'function') {
        callback(false, error)
      }
    }
  },

  connectDeviceServer: function() {
    DeviceConnection.socket = new WebSocket(DeviceConnection.wsUrl)

    window.postMessage({ type: DeviceConnection.messageType, data: WebSocket.CONNECTING }, '*')

    DeviceConnection.socket.onopen = function(msg) {
      DeviceConnection.heartCheck.reset().start() //传递信息
      window.postMessage({ type: DeviceConnection.messageType, data: WebSocket.OPEN }, '*')
      console.log('WebSocket opened!')
    }
    DeviceConnection.socket.onmessage = function(message) {

      DeviceConnection.heartCheck.reset().start()
      if (message.data == 'pong') {
        return
      }
      var data = JSON.parse(message.data)
      DeviceHandler.onReceiveMessage(data)
    }
    DeviceConnection.socket.onerror = function(error) {
      DeviceConnection.reconnect(DeviceConnection.wsUrl)
      window.postMessage({ type: DeviceConnection.messageType, data: WebSocket.CLOSED }, '*')
      console.log('Error: ' + error.name + error.number)
    }
    DeviceConnection.socket.onclose = function() {
      DeviceConnection.reconnect(DeviceConnection.wsUrl)
      window.postMessage({ type: DeviceConnection.messageType, data: WebSocket.CLOSED }, '*')
      console.log('WebSocket closed!')
    }
  },

  reconnect: function(url) {
    if (DeviceConnection.lockReconnect) {
      return
    }
    DeviceConnection.lockReconnect = true
    //没连接上会一直重连，设置延迟避免请求过多
    setTimeout(function() {
      DeviceConnection.connectDeviceServer(url)
      DeviceConnection.lockReconnect = false
    }, 10000)
  },

  //心跳检测
  heartCheck: {
    timeout: 10000, //10秒
    timeoutObj: null,
    serverTimeoutObj: null,
    reset: function() {
      clearTimeout(this.timeoutObj)
      clearTimeout(this.serverTimeoutObj)
      return this
    },
    start: function() {
      var self = this
      this.timeoutObj = setTimeout(function() {
        //这里发送一个心跳，后端收到后，返回一个心跳消息，
        //onmessage拿到返回的心跳就说明连接正常
        DeviceConnection.socket.send('ping')
        self.serverTimeoutObj = setTimeout(function() { //如果超过一定时间还没重置，说明后端主动断开了
          DeviceConnection.socket.close() //如果onclose会执行reconnect，我们执行ws.close()就行了.如果直接执行reconnect 会触发onclose导致重连两次
        }, self.timeout)
      }, this.timeout)
    }
  },

  // 保存配置
  set config(config) {
    localStorage.setItem(this.localStorageKey, JSON.stringify(config))
    this._config = config
  },

  get config() {
    if (this._config) {
      return this._config
    }
    const str = localStorage.getItem(this.localStorageKey)
    const config = JSON.parse(str) || {}
    config.ip = config.ip || '127.0.0.1'
    config.httpPort = config.httpPort || '30000'
    config.websocketPort = config.websocketPort || '30001'
    this._config = config
    return config
  },

  get wsUrl() {
    return 'ws://' + this.config.ip + ':' + this.config.websocketPort
  },

  get httpUrl() {
    if (!getIp()){
      return 'http://' + this.config.ip + ':' + this.config.httpPort
    }else {
      return 'http://' + getIp() + ':' + this.config.httpPort
    }
  },

  _config: null
}

/*
* 收信息格式
* {
*     messageType: 'message'|'photo'|'print'|'downloadTemplate',
*     model: {
*         success: boolean,
*         msg: string,
*         data: any,
*     }
* }
*
* */

const DeviceHandler = {

  MSG_TYPE_MESSAGE: 'message',
  MSG_TYPE_PHOTO: 'photo',
  MSG_TYPE_PRINT: 'print',
  MSG_TYPE_DOWNLOAD_TEMPLATE: 'downloadTemplate',

  // 打开照相机
  takePhoto: function() {
    DeviceHandler.sendCommand({ command: 'openCamera', data: '' })
  },

  // http方式打印 传入参数打印
  print: function(data) {
    return ajax.func({
      url: DeviceConnection.httpUrl + '/print',
      method: 'post-json',
      data: data
    })
  },

  // http方式打印
  printList: function(dataList, itemCallback = null, index = 0) {
    if (Array.isArray(dataList) && dataList.length > index) {
      DeviceHandler.print(dataList[index]).then(res => {
        if (typeof itemCallback === 'function') {
          itemCallback(dataList[index], res)
        }
        const i = index + 1
        DeviceHandler.printList(dataList, itemCallback, i)
      }).catch(e => {
        if (typeof itemCallback === 'function') {
          itemCallback(dataList[index], e)
        }
      })
    }
  },

  // http 方式打印，传入打印模版对应的数据 在循环中调用不保证顺序
  printWithData(data) {

    return ajax({
      url: DeviceConnection.httpUrl + '/printWithData',
      contentType: 'application/json',
      method: 'post',
      data: JSON.stringify(data)
    })

  },

  printWithDataToQueue(data) {
    // debugger
    // return ajax.func({
    //   url: DeviceConnection.httpUrl + '/printWithDataToQueue',
    //   contentType: 'application/json',
    //   type: 'POST',
    //   data: data
    // })
    return ajax({
      url: DeviceConnection.httpUrl + '/printWithDataToQueue',
      contentType: 'application/json',
      method: 'post-json',
      type: 'POST',
      data: JSON.stringify(data)
    })
  },

  // http方式打印 传入打印模版对应的数据列表 保证打印顺序
  printWithDataList: function(dataList, itemCallback = null, index = 0) {
    if (Array.isArray(dataList) && dataList.length > index) {
      DeviceHandler.printWithData(dataList[index]).then(res => {
        if (typeof itemCallback === 'function') {
          itemCallback(dataList[index], res)
        }
        const i = index + 1
        DeviceHandler.printWithDataList(dataList, itemCallback, i)
      }).catch(e => {
        if (typeof itemCallback === 'function') {
          itemCallback(dataList[index], e)
        }
      })
    }
  },

  sendCommand: function(cmd) {
    if (DeviceConnection.socket.readyState === DeviceConnection.socket.OPEN) {
      DeviceConnection.socket.send(JSON.stringify(cmd))
    } else if (DeviceConnection.socket.readyState === DeviceConnection.socket.CONNECTING) {
      $.yvan.msg('正在连接设备服务,请稍后再试')
    } else if (DeviceConnection.socket.readyState === DeviceConnection.socket.CLOSING) {
      $.yvan.msg('设备服务正在断开,请稍后再试')
    } else if (DeviceConnection.socket.readyState === DeviceConnection.socket.CLOSED) {
      DeviceHandler.checkDeviceServer()
    }
  },

  onReceiveMessage: function(message) {

    if (typeof (DeviceHandler[message.messageType]) === 'function') {
      DeviceHandler[message.messageType](message)
    } else if (Array.isArray(DeviceHandler[message.messageType])) {
      for (const item in DeviceHandler[message.messageType]) {
        if (typeof item === 'function') {
          item(message)
        }
      }
    }
    switch (message.messageType) {
      case DeviceHandler.MSG_TYPE_MESSAGE: {
        break
      }
      case DeviceHandler.MSG_TYPE_PHOTO: {

        break
      }
      case DeviceHandler.MSG_TYPE_PRINT: {

        break
      }
      case DeviceHandler.MSG_TYPE_DOWNLOAD_TEMPLATE: {

        break
      }
    }
    system.msg(message.msg)
  },

  checkDeviceServer: function() {
    var r = confirm('本机设备服务程序没有安装或者没有启动，如果没有下载点击确定进行下载，如果已经下载点击取消，手动启动设备服务程序')
    if (r == true) {
      debugger
    }
  }
}


const Camera = {
  // 拍照并上传照片
  takePhotoAndUpload: function(uploadUrl, param, success, photoNums) {

    // Camera.takePhoto(function (file,src) {
    //     var formData = new FormData();
    //     formData.append("file", file);
    //     formData.append("param", param);
    //     $.yvan.uploadFileCheckMd5(formData, {
    //         url: uploadUrl,
    //         success: function (data) {
    //             success(data);
    //         }
    //     });
    // }, photoNums);
    // $.ajax({
    //   url: uploadUrl,
    //   type: 'post',
    //   contentType: false,
    //   processData: false,
    //   mimeType: "multipart/form-data",
    //   data: formData,
    //   success: function (data) {
    //     upload(data);
    //   },
    //   error:function (data) {
    //     upload(data);
    //   }
    // });
  },

  // 拍照 获取照片file
  takePhoto: function(success, photoNums) {
    if (photoNums === undefined || photoNums === null) {
      photoNums = 1
    }
    DeviceHandler.takePhoto()
    DeviceHandler.photo = function(data) {
      photoNums--
      if (photoNums <= 0) {
        DeviceHandler.photo = null
      }
      var url = DeviceConnection.httpUrl + '/' + data.data + '?' + Math.random()

      var reader = new FileReader()
      getImageBlob(url, function(blob) {

        reader.readAsDataURL(blob)
        //blob转file
        var file = new File([blob], new Date().Format('yyyyMMddhhmmss_S') + '.jpg', {
          type: 'image/jpeg',
          lastModified: Date.now()
        })
        var src = window.URL.createObjectURL(blob)//这里传一个文件对象 例如：file.files[0]
        if (typeof success === 'function') {
          success(file, src)
        }
      })

      // 展示图片
      // reader.onload = function (e) {
      //   const img = document.createElement("img");
      //   img.src = e.target.result;
      //   document.body.appendChild(img);
      // };
    }
  }

}

//获取图片的Blob值
function getImageBlob(url, cb) {
  var xhr = new XMLHttpRequest()
  xhr.open('GET', url, true)
  xhr.responseType = 'blob'
  xhr.onload = function(oEvent) {
    if (this.status == 200) {
      if (cb) cb(xhr.response)
    }
  }
  xhr.send()
}

Date.prototype.Format = function(fmt) {
  var o = {
    'M+': this.getMonth() + 1,                 //月份
    'd+': this.getDate(),                    //日
    'h+': this.getHours(),                   //小时
    'm+': this.getMinutes(),                 //分
    's+': this.getSeconds(),                 //秒
    'q+': Math.floor((this.getMonth() + 3) / 3), //季度
    'S': this.getMilliseconds()             //毫秒
  }
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
  for (var k in o)
    if (new RegExp('(' + k + ')').test(fmt))
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
  return fmt
}


export { DeviceConnection, DeviceHandler, Camera }
